import AceCodeEditorContainer from "../../../../Components/Miscellaneous/Editor/AceCodeEditor/AceCodeEditorContainer";

const AceCodeEditor = () => {
  return <AceCodeEditorContainer />;
};

export default AceCodeEditor;
